<template>
  <div>
    <div class="text-center max-w-5xl mx-auto mb-12">
      <h3 class="my-6 text-xl flex items-center">
        <button
          class="mr-auto p-2 transition hover:bg-gray-200 active:bg-gray-300"
          @click.prevent="onSwitchToPrevWeek">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <span>
          KW {{ calendarWeek }} <br>
          <span class="text-black">
            {{ startOfWeekFormatted }} - {{ endOfWeekFormatted }}
          </span>
        </span>
        <button
          class="ml-auto p-2 transition hover:bg-gray-200 active:bg-gray-300 disabled:opacity-0 disabled:pointer-events-none"
          :disabled="!canGoFurther"
          @click.prevent="onSwitchToNextWeek">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </h3>
      <button
        class="text-xs hover:text-accent-brown"
        :class="{'pointer-events-none opacity-30': inSameWeek}"
        :disabled="inSameWeek"
        @click="resetToCurrentWeek">zurück zur aktuellen Woche</button>
    </div>
    <div class="overflow-hidden overflow-scroll max-w-full touch" style="-webkit-overflow-scrolling: touch;">
      <div class="w-full flex" style="min-width:1400px; min-height: 60vh;">
        <CalendarLane v-for="day in eachDay" :key="day" :day="day" :order="getOrderByDay(day)" :excluded="excludedDates" />
      </div>
    </div>
  </div>
</template>

<script>
import subWeeks from 'date-fns/subWeeks'
import addWeeks from 'date-fns/addWeeks'
import startOfWeek from 'date-fns/startOfWeek'
import isSameWeek from 'date-fns/isSameWeek'
import endOfWeek from 'date-fns/endOfWeek'
import getWeek from 'date-fns/getWeek'
import addDays from 'date-fns/addDays'
import getYear from 'date-fns/getYear'
import format from 'date-fns/format'
import isSameDay from 'date-fns/isSameDay'
import deLocale from 'date-fns/locale/de'
import parseISO from 'date-fns/parseISO'
import differenceInWeeks from 'date-fns/differenceInWeeks'

import { ordersByWeek } from './queries'
import CalendarLane from '@/Components/Calendar/CalendarLane'

export default {
  name: 'OrderCalendar',
  components: { CalendarLane },

  data: () => ({
    now: new Date(),
    selectedWeek: null,
    ordersByWeek: null,
  }),

  computed: {
    selected() {
      let date = this.$page.props.nextPossibleOrderDay ? this.$page.props.nextPossibleOrderDay : this.now

      return this.selectedWeek ? this.selectedWeek : startOfWeek(
        new Date(date),
        { weekStartsOn: 1 }
      )
    },

    startOfWeek() {
      return startOfWeek(this.selected, { weekStartsOn: 1 })
    },

    inSameWeek() {
      return isSameWeek(this.now, this.selected)
    },

    endOfWeek() {
      return endOfWeek(this.selected, { weekStartsOn: 1 })
    },

    startOfWeekFormatted() {
      return format(this.startOfWeek, 'dd. MMM', {
        locale: deLocale
      })
    },

    endOfWeekFormatted() {
      return format(this.endOfWeek, 'dd. MMM yyyy', {
        locale: deLocale
      })
    },

    calendarWeek() {
      return getWeek(this.selected, { weekStartsOn: 1, locale: deLocale })
    },

    eachDay() {
      return Array.from(Array(7)).map((e, i) => addDays(this.selected, i))
    },

    canGoFurther() {
      return differenceInWeeks(this.now, this.selected) >= 0
    },

    excludedDates() {
      const result = []

      if (this.ordersByWeek?.excludedDays) {
        for (let date of this.ordersByWeek?.excludedDays) {
          result.push(parseISO(date))
        }
      }

      return result
    }
  },

  watch: {
    calendarWeek: function() {
      if (this.calendarWeek) {
        this.$apollo.queries.ordersByWeek.refetch()
      }
    }
  },

  apollo: {
    ordersByWeek: {
      query: ordersByWeek,
      fetchPolicy: 'no-cache',
      variables () {
        return {
          year: this.calendarWeek === 1 ? getYear(this.endOfWeek) : getYear(this.selected),
          week: this.calendarWeek
        }
      },
    }
  },

  methods: {
    getOrderByDay(date) {
      if (!this.ordersByWeek || !this.ordersByWeek.data) {
        return null
      }

      let result = null
      this.ordersByWeek.data.map(order => {
        if (isSameDay(new Date(order.date), date)) {
          result = order
        }
      })

      return result
    },

    onSwitchToPrevWeek() {
      this.selectedWeek = subWeeks(startOfWeek(this.selected, { weekStartsOn: 1 }), 1)
    },

    onSwitchToNextWeek() {
      this.selectedWeek = addWeeks(startOfWeek(this.selected, { weekStartsOn: 1 }), 1)
    },

    resetToCurrentWeek() {
      this.selectedWeek = startOfWeek(
        this.now, { weekStartsOn: 1 }
      )
    }
  }
}
</script>
